import { createGetEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityApplicationOverview } from '@types';

export type GetDataSecurityApplicationOverviewResponse = DataSecurityApplicationOverview[];

export const getDataSecurityApplicationOverview = createGetEndpoint<void, GetDataSecurityApplicationOverviewResponse>(
	'/api/v3/data-security/organization/application-overview'
);
